import React, { FunctionComponent, useEffect } from "react";
import ScratcherProps from "./ScratcherProps";
import { useSelector } from "react-redux";
import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";
import styles from "./Scratcher.module.scss";

const Scratcher: FunctionComponent<ScratcherProps> = (props) => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);
    const settings = useSelector((state) => state.settings.content);

    const content = props.content;

    const { scratcherScriptID, scratcherSlugID, scriptSrcString, scriptIdentifier } = content;

    useEffect(() => {
        // Ensure all required data is available before running the effect
        if (!scratcherScriptID || !scratcherSlugID || !scriptSrcString || !scriptIdentifier) {
            console.log("Missing required properties for Scratcher initialization.");
            return;
        }

        const scriptId = scratcherScriptID;
        const scriptSrc = scriptSrcString;

        // Dynamically set the object
        window[scriptIdentifier] = {
            options: {
                slug: scratcherSlugID,
                width: "100%",
                height: 1100,
            },
        };

        // Load the script if not already loaded
        if (!document.getElementById(scriptId)) {
            const script = document.createElement("script");
            script.id = scriptId;
            script.src = scriptSrc;
            script.async = true;

            script.onload = () => {
                const iframeInterval = setInterval(() => {
                    const iframe = document.querySelector('iframe[src*="scratcher.io"]');
                    const container = document.getElementById("scratcher-container");

                    if (iframe && container) {
                        container.appendChild(iframe); // Move iframe to the container
                        clearInterval(iframeInterval);
                    }
                }, 100);

                setTimeout(() => clearInterval(iframeInterval), 5000); // Stop polling after 5 seconds
            };

            document.body.appendChild(script);
        }

        // Cleanup function
        return () => {
            const existingScript = document.getElementById(scriptId);
            if (existingScript) {
                existingScript.remove();
            }

            const iframe = document.querySelector('iframe[src*="scratcher.io"]');
            if (iframe) {
                iframe.remove();
            }
        };
    }, [scratcherScriptID, scratcherSlugID, scriptSrcString, scriptIdentifier]);

    return (
        <section
            className={combineClasses(styles.wrapper, ...wrapperClasses)}
            style={wrapperStyles}
        >
            {props.content.scriptID === "" ? (
                <div className={styles.container}>
                    {props.content.scriptID && props.content.slugID && settings?.venueId ? (
                        <div
                            className={styles.content}
                            rekom-inline-scratcher-form="true"
                            slug-id={props.content.slugID}
                            script-id={props.content.scriptID}
                            venue-id={settings?.venueId}
                        ></div>
                    ) : null}
                </div>
            ) : null}
            <div
                className={styles.container}
                id="scratcher-container"
            ></div>
        </section>
    );
};

export default Scratcher;
